import {useCallback, useState} from 'react'

export function useOptimizeRouteConfirmModal() {
  const [isOptimizeRouteConfirmModalOpened, setIsOptimizeRouteConfirmModalOpened] = useState(false)

  const openOptimizeRouteConfirmModalHandler = useCallback(() => {
    setIsOptimizeRouteConfirmModalOpened(true)
  }, [])

  const closeOptimizeRouteConfirmModalHandler = useCallback(() => {
    setIsOptimizeRouteConfirmModalOpened(false)
  }, [])

  return {
    isOptimizeRouteConfirmModalOpened,
    openOptimizeRouteConfirmModalHandler,
    closeOptimizeRouteConfirmModalHandler,
  }
}
